import React, { useMemo } from 'react'
import { PERMISSIONS } from '../../auth/constants'
import { PREFERENCES } from '../../user/constants'

import { useUserPreferencesFetch, useUserPreference } from '../../user/hooks'
import {
  useSigEventsFetch,
  useSigEventsIncidentsFetch,
} from '../../sigevents/hooks'
import { usePermissions } from '../../auth/hooks'

import BaseLayout from '../../common/components/BaseLayout'

import HiddenTab from '../../tabs/components/HiddenTab'
import Tab from '../../tabs/components/Tab'
import TabMenu from '../../tabs/components/TabMenu'
import TabPanel from '../../tabs/components/TabPanel'
import TabPanelContainer from '../../tabs/components/TabPanelContainer'

import UserPanel from '../../user/components/UserPanel'
import IncidentTogglePanel from '../../sigevents/components/IncidentTogglePanel'
import SigEventsPanel from '../../sigevents/components/SigEventsPanel'
import AddEventForm from '../../sigevents/components/AddEventForm'
import EditEventForm from '../../sigevents/components/EditEventForm'

import Map from '../../map/components/Map'
import Zoom from '../../map/components/Zoom'
import BasemapToggle from '../../map/components/BasemapToggle'
import Compass from '../../map/components/Compass'
import SigEventsLayer from '../../map/components/SigEventsLayer'
import SigEventsEditLayer from '../../map/components/SigEventsEditLayer'

import styles from './MainLayout.module.css'

const MainLayout = () => {
  useUserPreferencesFetch() // fetch user's preferences
  useSigEventsIncidentsFetch() // fetch active sig events incidents
  useSigEventsFetch() // fetch non-deleted sig events for active incidents

  const [canEdit] = usePermissions([PERMISSIONS.SIGNIFICANT_EVENTS_CREATE])

  const basemap = useUserPreference(PREFERENCES.DEFAULT_BASEMAP) || 'streets-vector'

  const mapPadding = useMemo(
    () => ({
      top: 60,
      left: 460,
      right: 10,
      bottom: 20,
    }),
    []
  )

  return (
    <BaseLayout title="Significant Events">
      <div className={styles.tabBar}>
        <TabMenu>
          <Tab path="/sigEvents/userMenu" icon="fa fa-user" />
          <Tab
            path="/sigEvents/eventList"
            defaultPath="/sigEvents"
            icon="fa fa-list-ul"
          />
          <Tab path="/sigEvents/incidentToggle" icon="fas fa-layer-group" />
          {canEdit && <Tab path="/sigEvents/addEvent" icon="fas fa-plus" />}
          {canEdit && (
            <HiddenTab path="/sigEvents/editEvent" icon="fas fa-pencil-alt" />
          )}
        </TabMenu>
      </div>
      <div className={styles.sideBar}>
        <TabPanelContainer>
          <TabPanel path="/sigEvents/userMenu">
            <UserPanel />
          </TabPanel>
          <TabPanel path="/sigEvents/incidentToggle">
            <IncidentTogglePanel />
          </TabPanel>
          <TabPanel path="/sigEvents/eventList">
            <SigEventsPanel />
          </TabPanel>
          {canEdit && (
            <TabPanel path="/sigEvents/addEvent">
              <AddEventForm />
            </TabPanel>
          )}
          {canEdit && (
            <TabPanel path="/sigEvents/editEvent">
              <EditEventForm />
            </TabPanel>
          )}
          <TabPanel>
            <SigEventsPanel />
          </TabPanel>
        </TabPanelContainer>
      </div>
      <Map basemap={basemap} padding={mapPadding}>
        <BasemapToggle
          position="top-right"
          next={basemap === 'streets-vector' ? 'satellite' : 'streets-vector'}
        />
        <Compass position="bottom-right" />
        <Zoom position="bottom-right" />
        <SigEventsLayer />
        <SigEventsEditLayer />
      </Map>
    </BaseLayout>
  )
}

export default MainLayout
